export const environment = {
  production: false,
  API_BASE_PATH: "https://api-dev.alkhafeef.com.sa/",
  ADMIN_URL: "https://admin-dev.alkhafeef.com.sa/account/login",
  WEB_URL: "https://web-dev.alkhafeef.com.sa",
  mapsApiKey: btoa(`${"AIzaSyAa5--GGnLEE0fvBHXNRRCByn_T0WvqrG0"}`)

};
